/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-corner-radius',
  templateUrl: './theme-option-tooltips-corner-radius.component.html',
  styleUrls: ['./theme-option-tooltips-corner-radius.component.css']
})
export class ThemeOptionTooltipsCornerRadiusComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_cornerRadius';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_cornerRadius', value);
  }

}
